<template lang="html">
  <section class="app-read-news" role="tablist">
    <b-card no-body class="mb-1" :key="idx" v-for="(newsItem, idx) in news">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="" v-b-toggle="'accordion-'+idx" variant="light">{{newsItem.title}}</b-button>
      </b-card-header>
      <b-collapse :id="'accordion-'+idx" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text class="d-flex">
            <div class="d-flex flex-wrap justify-content-between">
              <div><strong>news_id : </strong>{{newsItem.news_id}}</div>
              <div><strong>news_type_id : </strong>{{newsItem.news_type_id}}</div>
              <div><strong>title : </strong>{{newsItem.title}}</div>
              <div><strong>date_created : </strong>{{newsItem.date_created}}</div>
              <div><strong>date_published : </strong>{{newsItem.date_published}}</div>
              <div><strong>date_updated : </strong>{{newsItem.date_updated}}</div>
              <div><strong>content : </strong>{{newsItem.content}}</div>
              <div><strong>author : </strong>{{newsItem.author}}</div>
              <div><strong>src : </strong>{{newsItem.src}}</div>
              <div><strong>link : </strong>{{newsItem.link}}</div>
              <div><strong>overview : </strong>{{newsItem.overview}}</div>
              <div><strong>description : </strong>{{newsItem.description}}</div>
              <div><strong>src : </strong>{{newsItem.src}}</div>
            </div>
          </b-card-text>
          <b-card-text class="mt-4 text-center">
            <button type="button" class="btn btn-primary"
                    @click="navigateAway({id: newsItem.news_id, title: newsItem.title}, 'update')">
              Update
            </button>
            <button type="button" class="btn btn-danger ml-3"
                    @click="navigateAway({id: newsItem.news_id, title: newsItem.title}, 'delete')">
              Delete
            </button>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from "vuex";
export default {
  name: 'ReadNews',
  props: [],
  mounted () {},
  created () {
    this.readData()
      .then(data => this.news = data)
      .catch()
  },
  data () {
    return {
      news: null
    }
  },
  methods: {
    ...mapActions([
      'setCurrentElement',
      'setOperation',
      'setCrudComponent',
      'setPreviousOperation',
      'readData'
    ]),
    navigateAway(object, tab) {
      this.setCurrentElement(object);
      this.setPreviousOperation(this.getOperation);
      this.setOperation(tab);
      this.setCrudComponent('app-' + tab + '-' + this.getComponent);
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentElement',
      'getOperation',
      'getComponent'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-read-news {}
</style>



// WEBPACK FOOTER //
// src/components/news/ReadNews.vue